<!-- Template -->

<template>
    <div v-if="siteAddress" class="address">
        <h3>Address</h3>
        <p v-for="addressLine in siteAddress" :key="addressLine">{{ addressLine }}</p>
    </div>
</template>

<!-- Script -->

<script>
    export default {
        name: 'Address',

        props: [
            'address'
        ],


        computed: {
            siteAddress(){
                return this.address.split(', ');
            }
        }
    }
</script>

